// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__XoxRK","errorButton":"NotFoundPage_errorButton__U8uf6","title":"NotFoundPage_title__wsYAk"};